import React, { ReactNode } from 'react';
import cn from 'classnames';
import './index.css';
import NotificationIcon from './NotificationIcon';

type NoteBoxProps = {
  status: 'warning' | 'error' | 'info' | 'success' | 'none';
  children: ReactNode;
};

export default ({ status, children }: NoteBoxProps) => (
  <div
    className={cn('notification-wrapper', `notification-wrapper__${status}`)}
  >
    <div className="icon-wrapper">
      <NotificationIcon status={status} />
    </div>
    {children}
  </div>
);
